const MS_BEFORE_SHOW = 300;

import SubmitButton from "@/components/Shared/SubmitButton";

export default {
  components: {
    "submit-button": SubmitButton
  },

  data: function() {
    return {
      submitting: false,
      submittingTimeout: null
    };
  },

  methods: {
    startSubmission() {
      this.submittingTimeout = setTimeout(() => {
        this.submitting = true;
      }, MS_BEFORE_SHOW);
    },

    completeSubmission() {
      this.submitting = false;
      clearTimeout(this.submittingTimeout);
    }
  }
};
